module.exports = __webpack_public_path__ + "img/USAID-Horizontal_small.992ee17b.png";